/** 支付成功 → 价格页恢复选中套餐的桥接（避免 hook 注册时序问题） */

/** @type {((selection: object | null | undefined) => void | Promise<void>) | null} */
let restoreHandler = null

/** @type {object | null} */
let pendingSelection = null

export function registerCheckoutPlanRestoreHandler(handler) {
  restoreHandler = handler
}

export function unregisterCheckoutPlanRestoreHandler() {
  restoreHandler = null
}

export function stashPendingCheckoutPlanSelection(selection) {
  pendingSelection = selection ?? null
}

export function consumePendingCheckoutPlanSelection() {
  const selection = pendingSelection
  pendingSelection = null
  return selection
}

export function clearPendingCheckoutPlanSelection() {
  pendingSelection = null
}

export async function invokeCheckoutPlanRestore(selection) {
  if (selection) {
    stashPendingCheckoutPlanSelection(selection)
  }
  const payload = selection ?? pendingSelection
  if (!payload || !restoreHandler) return false
  await restoreHandler(payload)
  return true
}
